/**
 * Activity timeline card for the RFQ detail page.
 */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { History } from 'lucide-react';
import type { RFQActivityLog } from '../../lib/api';

interface RFQActivityTabProps {
  logs: RFQActivityLog[];
  formatDateTime: (date: string) => string;
}

export default function RFQActivityTab({ logs, formatDateTime }: RFQActivityTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <History className="h-5 w-5" />
          Activity History
        </CardTitle>
        <CardDescription>Timeline of changes and actions for this RFQ</CardDescription>
      </CardHeader>
      <CardContent>
        {logs.length > 0 ? (
          <div className="space-y-4">
            {logs.map((log, index) => (
              <div key={log.id} className="flex gap-4">
                <div className="relative">
                  <div className="h-3 w-3 rounded-full bg-primary mt-1.5" />
                  {index < logs.length - 1 && (
                    <div className="absolute left-1.5 top-4 bottom-0 w-px bg-border h-full" />
                  )}
                </div>
                <div className="flex-1 pb-4">
                  <div className="flex items-center gap-2 text-sm">
                    <span className="font-medium">{log.action_display || log.action}</span>
                    {log.performed_by_name && (
                      <span className="text-muted-foreground">by {log.performed_by_name}</span>
                    )}
                  </div>
                  <p className="text-sm text-muted-foreground mt-1">{log.description}</p>
                  <p className="text-xs text-muted-foreground mt-1">{formatDateTime(log.performed_at)}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            <History className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p>No activity recorded yet.</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
